export const DataType = Object.freeze({
  TEXT: "text",
  INT: "int",
  FLOAT: "float",
  HEX: "hex",
  MONEY: "money",
  CURRENCY: "currency",
  PERCENT: "percent",
  ALPHANUMERIC: "alphanumeric",
  DATE: "date",
  TIME: "time",
  LIST: "list",
  COMBO: "combo",
  ENUM: "enum",
  BOOL: "bool",
});

export const Operator = Object.freeze({
  OR: "or",
  IS: "is",
  IN: "in",
  BETWEEN: "between",
  MORE: "more",
  LESS: "less",
  MORE_OR_ZERO: "more or 0",
  BEGINS_WITH: "begins with",
  CONTAINS: "contains",
  ENDS_WITH: "ends with",
});

export const SortDirection = Object.freeze({
  ASC: "asc",
  DESC: "desc",
});

export const W2UiCmd = Object.freeze({
  GET_RECORDS: "get-records",
  SAVE_RECORDS: "save-records",
  DELETE_RECORDS: "delete-records",
});

export const SortItem = {
  asc: (field: string) => {
    return { field, direction: SortDirection.ASC };
  },
  desc: (field: string) => {
    return { field, direction: SortDirection.DESC };
  },
};

export const SearchItem = {
  textOr: (field: string, values: any) => {
    return { field, values, type: DataType.TEXT, operator: Operator.OR };
  },
  textIs: (field: string, values: any) => {
    return { field, values, type: DataType.TEXT, operator: Operator.IS };
  },
  textIn: (field: string, values: any) => {
    return { field, values, type: DataType.TEXT, operator: Operator.IN };
  },
  textContains: (field: string, values: any) => {
    return { field, values, type: DataType.TEXT, operator: Operator.CONTAINS };
  },
  booleanIs: (field: string, values: any) => {
    return { field, values, type: DataType.BOOL, operator: Operator.IS };
  },
  intIs: (field: string, values: any) => {
    return { field, values, type: DataType.INT, operator: Operator.IS };
  },
  intIn: (field: string, values: any) => {
    return { field, values, type: DataType.INT, operator: Operator.IN };
  },
  intBetween: (field: string, values: any) => {
    return { field, values, type: DataType.INT, operator: Operator.BETWEEN };
  },
  intMore: (field: string, values: any) => {
    return { field, values, type: DataType.INT, operator: Operator.MORE };
  },
  intLess: (field: string, values: any) => {
    return { field, values, type: DataType.INT, operator: Operator.LESS };
  },
  intMoreOrZero: (field: string, values: any) => {
    return { field, values, type: DataType.INT, operator: Operator.MORE_OR_ZERO };
  },
  floatBetween: (field: string, values: any) => {
    return { field, values, type: DataType.FLOAT, operator: Operator.BETWEEN };
  },
  floatMore: (field: string, values: any) => {
    return { field, values, type: DataType.FLOAT, operator: Operator.MORE };
  },
  floatLess: (field: string, values: any) => {
    return { field, values, type: DataType.FLOAT, operator: Operator.LESS };
  },
  floatMoreOrZero: (field: string, values: any) => {
    return { field, values, type: DataType.FLOAT, operator: Operator.MORE_OR_ZERO };
  },
  dateBetween: (field: string, values: any) => {
    return { field, values, type: DataType.DATE, operator: Operator.BETWEEN };
  },
  dateIs: (field: string, values: any) => {
    return { field, values, type: DataType.DATE, operator: Operator.IS };
  },
  inList: (field: string, values: any) => {
    return { field, values, type: DataType.LIST, operator: Operator.IN };
  },
};
